module.exports = __webpack_public_path__ + "static/media/todayDistance.481d5e65.svg";